import { render, staticRenderFns } from "./Hospitalisation.vue?vue&type=template&id=2acd6606&scoped=true"
import script from "./Hospitalisation.vue?vue&type=script&lang=js"
export * from "./Hospitalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd6606",
  null
  
)

export default component.exports